"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileProvider = UserProfileProvider;
const React = __importStar(require("react"));
const Sentry = __importStar(require("@sentry/browser"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const Authorization = __importStar(require("@genesys/shared/lib/authorization"));
const GraphQLQuery = __importStar(require("../graphql-query"));
const MutationsQueueUser = __importStar(require("../mutations-queue-user"));
const Contexts = __importStar(require("../contexts"));
const OptimisticCachePatch = __importStar(require("./optimistic-cache-instructions"));
const userQuery = (0, graphql_tag_1.default) `
  query UserProfileProviderUserData {
    user {
      userProfile {
        id
        name
        userName
        lastLogin
        applicationClaims {
          id
          key
          context
          values
        }

        currencies {
          id
          name
          signBefore
          signAfter
        }

        userSettings {
          id
          culture {
            id
            locale {
              id
            }
            language {
              id
            }
            currency {
              id
            }
          }

          climate {
            id
            location {
              id
            }
          }

          wizardSettings {
            id
            lastCreatedSystemType
            lastSelectedLabels
          }

          sales {
            id
            defaultSalesOrganisation
          }
        }

        salesOrganisations {
          id
          name
        }
      }
    }
  }
`;
function UserProfileProvider({ children }) {
    return (React.createElement(MutationsQueueUser.MutationsQueue, null, ({ mutationQueue, queueAndFlush }) => (React.createElement(GraphQLQuery.QueryUserSimple, { query: userQuery, variables: {}, mutationsQueue: mutationQueue }, userData => {
        return (React.createElement(UserProfileProviderInternal, { userData: userData, children: children, queueAndFlush: queueAndFlush }));
    }))));
}
class UserProfileProviderInternal extends React.Component {
    constructor(props) {
        super(props);
        this.setCulture = (settings) => {
            this.props.queueAndFlush([
                {
                    type: "AddToQueueMutationDescription",
                    mutation: OptimisticCachePatch.setCultureQueuedMutation(settings, this.props.userData.user.userProfile.id)
                }
            ]);
        };
        this.setInitialSettings = (culture, activeAmountProfileId, climate) => {
            this.props.queueAndFlush([
                {
                    type: "AddToQueueMutationDescription",
                    mutation: OptimisticCachePatch.setInitialSettings(culture, activeAmountProfileId, climate)
                }
            ]);
        };
        this.setDefaultSalesOrganisation = (defaultSalesOrganisationCode) => {
            const code = defaultSalesOrganisationCode !== undefined
                ? defaultSalesOrganisationCode
                : null;
            this.props.queueAndFlush([
                {
                    type: "AddToQueueMutationDescription",
                    mutation: OptimisticCachePatch.setDefaultSalesOrganisation(code, this.props.userData.user.userProfile.id)
                }
            ]);
        };
        this.resetUserSettings = () => {
            this.props.queueAndFlush([
                {
                    type: "AddToQueueMutationDescription",
                    mutation: OptimisticCachePatch.resetUserSettings()
                }
            ]);
        };
        this.updateWizardSettings = (lastCreatedSystemType, lastSelectedLabels) => {
            this.props.queueAndFlush([
                {
                    type: "AddToQueueMutationDescription",
                    mutation: OptimisticCachePatch.updateWizardSettings(lastCreatedSystemType, lastSelectedLabels, this.props.userData.user.userProfile.id)
                }
            ]);
        };
        const { applicationClaims, currencies, name, userName, lastLogin } = props.userData.user.userProfile;
        this.state = {
            childProps: {
                name,
                userName,
                lastLogin,
                applicationClaims: Authorization.toObjectClaims(applicationClaims),
                currencies: currencies.map(c => ({
                    id: c.id,
                    name: c.name,
                    signAfter: c.signAfter || undefined,
                    signBefore: c.signBefore || undefined
                })),
                currency: "EUR",
                language: "en-GB",
                locale: "en-GB",
                lastCreatedSystemType: undefined,
                lastSelectedLabels: [],
                defaultSalesOrganisation: undefined,
                salesOrganisations: [],
                defaultLocationId: undefined,
                setCulture: this.setCulture,
                setInitialSettings: this.setInitialSettings,
                setDefaultSalesOrganisation: this.setDefaultSalesOrganisation,
                resetUserSettings: this.resetUserSettings,
                updateWizardSettings: this.updateWizardSettings
            }
        };
    }
    componentDidMount() {
        Sentry.setUser({
            username: this.state.childProps.userName
        });
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { salesOrganisations, userSettings } = nextProps.userData.user.userProfile;
        const { currency, language, locale } = userSettings.culture;
        const childProps = Object.assign(Object.assign({}, prevState.childProps), { currency: (currency && currency.id), language: (language && language.id), locale: (locale && locale.id), lastCreatedSystemType: valueOrUndefined(userSettings.wizardSettings.lastCreatedSystemType), lastSelectedLabels: userSettings.wizardSettings.lastSelectedLabels, defaultSalesOrganisation: valueOrUndefined(userSettings.sales.defaultSalesOrganisation), salesOrganisations: salesOrganisations, defaultLocationId: (userSettings.climate.location && userSettings.climate.location.id) ||
                undefined });
        return {
            childProps
        };
    }
    render() {
        return (React.createElement(Contexts.UserProfileContext.Provider, { value: this.state.childProps }, React.Children.only(this.props.children)));
    }
}
function valueOrUndefined(value) {
    if (!value) {
        return undefined;
    }
    return value;
}
//# sourceMappingURL=user-profile-provider.js.map